import { render, staticRenderFns } from "./ByCustomerList.vue?vue&type=template&id=bcd1fa8e&"
import script from "./ByCustomerList.vue?vue&type=script&lang=js&"
export * from "./ByCustomerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports